import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgPipette(props) {
	return (
		<SvgIcon {...props}>
			<path
				d="M14.753 7.425l2.322 2.322-8.516 8.516-1.355.194-2.129.968.968-2.13.194-1.354 8.516-8.516zm3.656-3l1.666 1.666-3.333 3.334-1.667-1.667 3.334-3.333zM13.4 6l5 5"
				stroke="currentColor"
				strokeWidth={1.2}
				fill="none"
				fillRule="evenodd"
				strokeLinejoin="round"
			/>
		</SvgIcon>
	)
}

export default SvgPipette
